import * as React from 'react';
import { RouteObject } from 'react-router-dom';

const ClientReports = React.lazy(
    () => import(/* webpackChunkName: "client-reports" */ '../../../../containers/Client/Reports')
);
const ClientReportsTable = React.lazy(
    () =>
        import(
            /* webpackChunkName: "client-reports-table" */ '../../../../containers/Client/Reports/children/ReportsTable'
        )
);
const ClientReportAssetLiabilities = React.lazy(
    () =>
        import(
            /* webpackChunkName: "client-reports-asset-liabilities" */ '../../../../containers/Client/Reports/children/AssetsLiabilities'
        )
);
const ClientReportPnl = React.lazy(
    () => import(/* webpackChunkName: "client-reports-pnl" */ '../../../../containers/Client/Reports/children/Pnl')
);

export const ClientReportsRoutes: RouteObject = {
    path: 'reports',
    element: (
        <React.Suspense fallback={<>...</>}>
            <ClientReports />
        </React.Suspense>
    ),
    children: [
        {
            index: true,
            element: (
                <React.Suspense fallback={<>...</>}>
                    <ClientReportsTable />
                </React.Suspense>
            )
        },
        {
            path: 'asset-liabilities',
            element: (
                <React.Suspense fallback={<>...</>}>
                    <ClientReportAssetLiabilities />
                </React.Suspense>
            )
        },
        {
            path: 'pnl',
            element: (
                <React.Suspense fallback={<>...</>}>
                    <ClientReportPnl />
                </React.Suspense>
            )
        }
    ]
};
